module.exports = __webpack_public_path__ + "img/vodEnabled.937726.svg";